import { render } from "./AppHeader.vue?vue&type=template&id=7a6140cc&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=7a6140cc&scoped=true&lang=scss"

import exportComponent from "/home/xpixel/htdocs/xpixel.ru/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6140cc"]])

export default __exports__